var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 78,
    viewBox: "0 0 120 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 5.16189C19.6936 2.52595 22.0768 0.688721 24.8024 0.688721H112.217C116.151 0.688721 119.021 4.41107 118.019 8.21555L101 72.8953C100.306 75.5313 97.9232 77.3685 95.1976 77.3685H7.78304C3.84906 77.3685 0.979472 73.6462 1.98056 69.8417L18.9999 5.16189Z",
    fill: "#7630FF",
    fillOpacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 64.7245C46.15 64.7245 42.8542 63.6063 40.1125 61.3698C37.3708 59.1333 36 56.4448 36 53.3041C36 50.1635 37.3708 47.475 40.1125 45.2385C42.8542 43.002 46.15 41.8838 50 41.8838C51.3417 41.8838 52.5667 42.0265 53.675 42.312C54.8417 42.5499 55.95 42.9306 57 43.4541V13.3328H78V24.7532H64V53.3041C64 56.4448 62.6292 59.1333 59.8875 61.3698C57.1458 63.6063 53.85 64.7245 50 64.7245Z",
    fill: "#FEF7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.f4a6e367974560acfbae9e5f71386f3b.svg";
export { ForwardRef as ReactComponent };